import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { foraDaProva } from '@/features/relatos/podeRelatar';
import { aplicarAgora, dependenciasPadrao, deveMostrarAviso, EVENTO_TELAS_PRONTAS, pacotePronto } from './atualizacaoPronta';

/** O aviso discreto "Atualização pronta · Aplicar agora" (1.4) — ver `atualizacaoPronta.ts`. Montado uma vez, em `App.tsx`. */
export function AvisoDeAtualizacaoPronta() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [mostrar, setMostrar] = useState(false);
  const [atualizando, setAtualizando] = useState(false);
  const [recado, setRecado] = useState<string | null>(null);

  const conferir = useCallback(async () => {
    const nativo = Capacitor.isNativePlatform();
    const fora = foraDaProva(pathname);
    if (!nativo || !user || user.role === 'STUDENT' || !fora) { setMostrar(false); return; }
    try {
      const d = await dependenciasPadrao();
      const pacote = await pacotePronto(d);
      if (!pacote) { setMostrar(false); return; }
      const provaGuardada = await d.provaGuardada();
      setMostrar(deveMostrarAviso({ nativo, papel: user.role, foraDaProva: fora, pendente: { versao: pacote.versao, abertura: '' }, baixado: true, provaGuardada }));
    } catch { setMostrar(false); }
  }, [user, pathname]);

  useEffect(() => { void conferir(); }, [conferir]);
  useEffect(() => { const h = () => void conferir(); window.addEventListener(EVENTO_TELAS_PRONTAS, h); return () => window.removeEventListener(EVENTO_TELAS_PRONTAS, h); }, [conferir]);

  if (atualizando) {
    return <div className="fixed inset-0 z-[90] flex items-center justify-center bg-white text-base font-medium text-gray-800" data-testid="atualizando">Atualizando…</div>;
  }
  if (!mostrar) return null;
  const aplicar = async () => {
    setRecado(null); setAtualizando(true);
    try {
      const r = await aplicarAgora(await dependenciasPadrao());
      if (r !== 'aplicando') { setAtualizando(false); setMostrar(false); if (r === 'prova') setRecado('Há uma prova guardada neste aparelho: a atualização fica para depois dela.'); }
    } catch { setAtualizando(false); setRecado('Não foi possível aplicar agora. A atualização entra na próxima vez que o app abrir.'); }
  };
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] flex justify-center px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pointer-events-none">
      <button type="button" onClick={() => void aplicar()} data-testid="atualizacao-pronta"
        className="pointer-events-auto flex min-h-[44px] items-center gap-2 rounded-full bg-gray-900/90 px-4 py-2 text-sm text-white shadow-lg">
        <span>Atualização pronta</span><span aria-hidden>·</span><span className="font-semibold underline">Aplicar agora</span>
      </button>
      {recado && <p className="pointer-events-auto absolute bottom-16 rounded-md bg-gray-900 px-3 py-2 text-xs text-white" role="status">{recado}</p>}
    </div>
  );
}
